import { useEffect } from 'react'
export default function useDataTracking (pathname) {
  useEffect(() => {
    /*
      Since the Page components are loaded asynchronously
      the bellow code is to wait for the components to be loaded
      before the hover GA script runs so that we can attach the
      listeners to the relevant elements.
    */
    let timeoutId = null
    let elements = []
    const callTracking = (e) => {
      const trackedNodes = e.target.getAttribute('data-tracking')
      const trackingData = JSON.parse(trackedNodes)
      trackingData.trackHoverEvent && registerTrackingEvent(trackingData)
    }

    const addMouseEnterEvent = (e) => {
      if (!timeoutId) {
        timeoutId = setTimeout(() => {
          callTracking(e)
        }, 1500)
      }
    }

    const addMouseLeaveEvent = () => {
      if (timeoutId) {
        clearTimeout(timeoutId)
        timeoutId = null
      }
    }
    setTimeout(() => {
      elements = document.querySelectorAll('[data-tracking]')
      if (elements.length) {
        for (const ele of elements) {
          ele.addEventListener('mouseenter', addMouseEnterEvent)
          ele.addEventListener('mouseleave', addMouseLeaveEvent)
        }
      }
    }, 200)
    return () => {
      if (elements.length) {
        for (const ele of elements) {
          ele.removeEventListener('mouseenter', addMouseEnterEvent)
          ele.removeEventListener('mouseleave', addMouseLeaveEvent)
        }
      }
    }
  }, [pathname])

  const registerTrackingEvent = ({ label, name, mvtVariant, mvtCampaign }) => {
    window.utag?.link({
      category: 'Web - Albatross',
      action: 'Hover',
      label,
      name: name && name,
      mvtVariant,
      mvtCampaign
    })
  }
}
